import { render, staticRenderFns } from "./PanelEvent.vue?vue&type=template&id=599f2353"
import script from "./PanelEvent.vue?vue&type=script&lang=js"
export * from "./PanelEvent.vue?vue&type=script&lang=js"
import style0 from "./PanelEvent.vue?vue&type=style&index=0&id=599f2353&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QCheckbox});
